import Lookup from 'src/componentes/select2';

function IndicadorRiscoLookup({ ...props }) {
  return <Lookup labelKey="nome" valueKey="id" url="/IndicadorRiscoLookup" {...props} />;
}

export default IndicadorRiscoLookup;
